var _rect, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulelessonsanytime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_40342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3543,
    width: 1440,
    height: 8103,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3543,
    width: 1440,
    height: 8306,
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -312,
    width: 1295,
    height: 1322,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_827_40342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 19H40.75V18C40.75 17.7348 40.6446 17.4804 40.4571 17.2929C40.2696 17.1054 40.0152 17 39.75 17C39.4848 17 39.2304 17.1054 39.0429 17.2929C38.8554 17.4804 38.75 17.7348 38.75 18V19H25.25V18C25.25 17.7348 25.1446 17.4804 24.9571 17.2929C24.7696 17.1054 24.5152 17 24.25 17C23.9848 17 23.7304 17.1054 23.5429 17.2929C23.3554 17.4804 23.25 17.7348 23.25 18V19H19C18.2044 19 17.4413 19.3161 16.8787 19.8787C16.3161 20.4413 16 21.2044 16 22V44C16 44.7956 16.3161 45.5587 16.8787 46.1213C17.4413 46.6839 18.2044 47 19 47H45C45.7956 47 46.5587 46.6839 47.1213 46.1213C47.6839 45.5587 48 44.7956 48 44V22C48 21.2044 47.6839 20.4413 47.1213 19.8787C46.5587 19.3161 45.7956 19 45 19ZM19 21H23.25V22C23.25 22.2652 23.3554 22.5196 23.5429 22.7071C23.7304 22.8946 23.9848 23 24.25 23C24.5152 23 24.7696 22.8946 24.9571 22.7071C25.1446 22.5196 25.25 22.2652 25.25 22V21H38.75V22C38.75 22.2652 38.8554 22.5196 39.0429 22.7071C39.2304 22.8946 39.4848 23 39.75 23C40.0152 23 40.2696 22.8946 40.4571 22.7071C40.6446 22.5196 40.75 22.2652 40.75 22V21H45C45.2652 21 45.5196 21.1054 45.7071 21.2929C45.8946 21.4804 46 21.7348 46 22V24.5H18V22C18 21.7348 18.1054 21.4804 18.2929 21.2929C18.4804 21.1054 18.7348 21 19 21ZM45 45H19C18.7348 45 18.4804 44.8946 18.2929 44.7071C18.1054 44.5196 18 44.2652 18 44V26.5H46V44C46 44.2652 45.8946 44.5196 45.7071 44.7071C45.5196 44.8946 45.2652 45 45 45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5001 29.7056C38.2891 29.5454 38.0233 29.4754 37.7608 29.511C37.4983 29.5467 37.2607 29.685 37.1001 29.8956L29.7951 39.4556L26.8551 36.3156C26.7651 36.2197 26.6572 36.1425 26.5374 36.0884C26.4176 36.0342 26.2883 36.0042 26.1569 36C26.0255 35.9959 25.8946 36.0176 25.7716 36.064C25.6486 36.1104 25.5359 36.1806 25.4401 36.2706C25.3442 36.3605 25.267 36.4685 25.2129 36.5883C25.1587 36.7081 25.1287 36.8374 25.1245 36.9688C25.1204 37.1002 25.1421 37.2311 25.1885 37.3541C25.2349 37.4771 25.3051 37.5897 25.3951 37.6856L29.1451 41.6856C29.2388 41.7852 29.3519 41.8646 29.4774 41.9188C29.603 41.9729 29.7383 42.0008 29.8751 42.0006H29.9251C30.0705 41.993 30.2126 41.9537 30.3413 41.8855C30.4699 41.8172 30.5822 41.7217 30.6701 41.6056L38.6701 31.1056C38.8325 30.8971 38.9057 30.6328 38.8739 30.3705C38.842 30.1082 38.7076 29.8691 38.5001 29.7056Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -107.5,
    y: -3542.5,
    width: 1439,
    height: 8102,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -4487,
    y: -12674,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3543,
    width: 1440,
    height: 8103,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulelessonsanytime);
export default __webpack_public_path__ + "static/media/schedule lessons anytime.10a5b1e8455d6564872111a294fce99f.svg";
export { ForwardRef as ReactComponent };